import { render } from "./refundPolicyBannerComponent.vue?vue&type=template&id=64a45343"
import script from "./refundPolicyBannerComponent.vue?vue&type=script&lang=js"
export * from "./refundPolicyBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__